import React, { useCallback, useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';

import { useAuth } from '../../hooks/auth';
import { useAlert } from '../../hooks/alert';

import Input from '../../components/Input';
import getValidationErrors from '../../utils/getValidationErrors';

interface signInFormData {
  email: string;
  password: string;
}

interface HistoryProps {
  referrer: string;
}

const Login: React.FC = () => {
  const formRef = useRef<FormHandles>(null);

  const [loading, setLoading] = useState(false);

  const { signIn } = useAuth();
  const { showAlert } = useAlert();
  const history = useHistory<HistoryProps>();

  const handleSubmit = useCallback(
    async (data: signInFormData) => {
      try {
        setLoading(true);

        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          email: Yup.string()
            .required('Digite seu e-mail')
            .email('Digite um e-mail válido'),
          password: Yup.string().required('Digite sua senha'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await signIn({
          email: data.email,
          password: data.password,
        });

        const redirectPage = history.location.state?.referrer
          ? history.location.state.referrer
          : '/budgets';

        history.push(redirectPage);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRef.current?.setErrors(errors);
        } else {
          let errorMessage = 'confira seus dados de acesso.';
          if (error.response?.data?.error === 'Cadastro pendente') {
            errorMessage =
              'aguarde a aprovação de seu cadastro pelo moderador.';
          }
          showAlert({
            type: 'error',
            title: 'Algum erro aconteceu',
            description: `Ocorreu algum erro ao fazer login: ${errorMessage}`,
          });
        }
      } finally {
        setLoading(false);
      }
    },
    [history, showAlert, signIn],
  );

  return (
    <>
      <Form onSubmit={handleSubmit} ref={formRef}>
        <h5 className="spacer">ÁREA RESTRITA</h5>

        <p>
          Lorem ipsum dolor sit amet, qui minim labore adipisicing minim sint
          cillum sint consectetur cupidatat.
        </p>

        <div className="spacer" />

        <div className="row">
          <div className="col-lg-6 offset-lg-3 offset-0">
            <div className="form-group">
              <label htmlFor="email">E-MAIL</label>
              <Input
                name="email"
                type="text"
                className="form-control"
                id="email"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 offset-lg-3 offset-0">
            <div className="form-group">
              <label htmlFor="password">SENHA</label>
              <Input
                name="password"
                type="password"
                className="form-control"
                id="password"
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-6 offset-lg-3 offset-0">
            <div className="row">
              <div className="col-12 col-sm-6">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? 'CARREGANDO...' : 'ACESSAR'}
                </button>
              </div>
              <div className="col-12 col-sm-6 d-flex align-items-center align-items-sm-end justify-content-center flex-column">
                <div className="p-4 p-sm-0">
                  <Link to="register">Quero me cadastrar</Link>
                  <br />
                  <Link to="login-forget">Esqueci minha senha</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </>
  );
};

export default Login;
